import i18next from 'i18next';
import ICU from 'i18next-icu';
import loadTranslations from './load-translations';

function initializeI18next() {
  return i18next
    .use(ICU)
    .init({
      nsSeparator: false,
      keySeparator: false,
      lowerCaseLng: true,
    })
    .then(loadTranslations);
}

export default initializeI18next;
